export default "__VITE_ASSET__vMNH6F$z__"